export const DISCOUNT_OFFER_CART_ID = 'discount-offer';
